module.exports = {
  menu: {
    home: "首页",
    product: "产品和服务",
    aboutus: "关于我们",
    contactus: "联系我们",
    login: "商户/代理商登录"
  },
  select: {
    title: "语言选择",
    lang: [
      {
        key: "zh-CN",
        name: "简体中文"
      },
      {
        key: "zh-TW",
        name: "繁体中文"
      },
      {
        key: "en",
        name: "英文"
      },
      {
        key: "ja",
        name: "日语"
      },
      {
        key: "ko",
        name: "韩语"
      }
    ]
  },
  brandIntro: {
    title: "上海富惠网络有限公司",
    slogan: "Slogan：以数字科技，赋能全球商业长效增长",
    intro: {
      title: "品牌简介",
      paragraphs: [
        "Link2shops（上海富惠网络有限公司）聚焦境内外企业数字化增长服务领域，是以销售促成、会员增长等结果为核心导向的AI商业增长解决方案提供商。公司深度融合各类前沿大模型，将人工智能与数字化营销、会员权益服务、全域获客深度绑定，提供集系统研发、供应链协同、推广分销、精细化运营的全链路数字化解决方案，通过自研AI销售系统，直击企业拓客难、转化低、人效不足的核心痛点，助力企业高效搭建拉新、促活、转化、复购的闭环增长体系，让技术落地真正转化为业绩增长与效率提升的实际成果。",
        "依托深厚的技术沉淀与行业实践，公司率先落地自研核心产品AISalesPro AI销售系统，以智能外呼（语音）/智能客服（线上）、意图理解、异议处理、意向筛选、全流程促单的一体化销售能力，替代传统重复性人工工作，大幅降低企业运营成本、提升销售转化效率，实现AI技术与商业增长的深度落地融合，始终坚持\u201c不为技术而技术，只为企业结果而服务\u201d的核心理念。"
      ]
    },
    credentials: {
      title: "权威资质与技术保障",
      content:
        "作为国家认定高新技术企业、上海市专精特新中小企业，Link2shops技术体系与全平台服务系统，已通过PCI DSS支付卡行业数据安全认证、国家网络安全等级保护三级认证等多项国内外权威安全及技术认证，以严苛合规标准筑牢数据安全与业务信任防线，保障每一项智能服务、每一笔交易链路安全稳定、合规可溯。"
    },
    background: {
      title: "品牌背景与全球服务网络",
      content:
        "由富友集团战略投资，总部立足上海，在北京、武汉、香港、东京等地设立分支机构，全球服务网络覆盖中、日、韩、新、泰等多个国家与地区。深耕行业多年，已累计服务近300个知名品牌、超10000间线下门店，业务覆盖餐饮购物、娱乐出行、金融权益、生活服务等多元商业场景，具备全球化、多场景、规模化的落地服务能力。"
    },
    ecosystem: {
      title: "全域生态伙伴矩阵",
      intro:
        "深度链接全球顶级商业生态资源，作为微信、支付宝、美团等主流流量平台官方服务商，助力企业高效打通公私域流量闭环；核心生态合作伙伴涵盖：",
      categories: [
        {
          title: "金融机构",
          partners: ["Visa", "建行", "工行", "中行", "招行"],
          suffix: "等"
        },
        {
          title: "航司与运营商",
          partners: ["春秋航空", "东方航空", "吉祥航空", "中国移动"]
        },
        {
          title: "全球商旅平台",
          partners: ["Booking", "Agoda", "携程", "美团", "抖音"]
        }
      ]
    },
    aiStrategy: {
      title: "AI战略布局与长期价值",
      content:
        "公司将人工智能作为核心发展战略，持续深耕大模型商用、智能营销、企业效率数字化领域，不断拓展AI产品矩阵。未来将围绕企业全流程经营需求，陆续推出AI智能跟单、全域智能运营、团队效率管理、数据化增长复盘等系列AI产品与解决方案，从前端智能获客、中端业务转化，到后端效率管控，全链路以AI科技赋能企业数字化升级，持续为全球商业伙伴实现降本增效、业绩增收与长效稳健增长。"
    }
  },
  products: {
    servers: [
      {
        title: "分销服务",
        subTitle: "为商户提供一站式系统集成服务方案",
        desc:
          "Link2shops为海外商户提供一站式的系統集成服務方案,帮助商户将商品或服务快速预分销至中国境内及部分国外的航空公司、银行、OTA（在线旅行社）等渠道，并同时提供包括在线预订、移动支付、顾客服务支持、市场推广等服务，在为商户增加销售额的同时，为商户提供销售便利，提升品牌影响力。"
      },
      {
        title: "市场推广服务",
        subTitle: "为商户提供面向中国高端客户的市场推广服务",
        desc:
          "Link2shops是中国的银行、航空公司、大型企业集团等知名平台的高端客户权益提供商，能够帮助商户根据目标客户类型、平台特点定制化市场活动，并将商户信息发布推广到相关平台，在吸引高端客户消费的同时，借平台的品牌影响力极大提升商户自身品牌价值。"
      },
      {
        title: "零售系统软件服务",
        subTitle: "为商户提供零售系统软件服务",
        desc:
          "Link2shops能够为商户提供以下系统软件服务，包括：电子券系统（包含分销、核销）、预订订座系统、收款系统（如支付宝、微信、苹果支付）等。"
      }
    ]
  },
  company: {
    title: "合作伙伴",
    record: "沪ICP备17033610号-1",
    name: "上海富惠网络有限公司",
    website: "网址",
    customer: "客服热线",
    business: "商务合作",
    fax: "传真",
    email: "电邮",
    address: "地址",
    addressDesc: "上海市浦东新区金藏路351弄6号楼2楼",
    companyType1: "金融机构",
    companyType2: "商户"
  },
  contact: {
    menu1: "联系我们",
    menu2: "商务合作"
  },
  about: {
    desc1:
      "上海富惠网络有限公司（Link2shops）是国内领先的会员服务系统解决方案提供商，专注于面向机构提供包括会员系统、风控反欺诈、智能聚合收银台等技术解决方案。目前服务的机构包括Visa、工行、农行、中行、建行、平安、中信、广发、招行等，提供的会员服务应用范围覆盖数字产品、零售餐饮、跨境电商等领域，合作伙伴涉及中国、日本、韩国、新加坡、泰国等国家近300个品牌超过8000个门店。Link2shops总部位于上海，在北京、香港、东京等地设立有子公司、分公司或办事处，并在武汉设有云计算研发中心。",
    desc2:
      "Link2shops目前服务了上百家卡组织、金融机构，包括Visa、工商银行、中国银行、建设银行、招商银行、浦发银行、中信银行、平安银行、广发银行等，并为多家知名机构企业、福利平台等提供忠诚度解决方案，如中国移动、AON等，Link2shops同时为线下零售连锁免税店餐饮等商户提供会员营销及忠诚度服务方案，目前合作范围已覆盖境内外上万家门店，合作品牌包括高岛屋、ASICS、LAOX、东武百货、山田电机、堂吉诃德等。",
    desc3:
      "上海富惠网络有限公司（以下简称“富惠”）充分理解网络安全的重要性，同时富惠也理解各合作渠道及客户对此的担忧与高度关注。随着电信网络和信息技术的不断演进与发展，网络安全面临的威胁和挑战将日益严重。富惠也心存忧患。富惠对此高度重视，并致力于采取切实有效的措施提升产品和服务的安全性，从而帮助客户规避和减少安全方面的风险，以赢得各利益相关者的信赖。在此承诺：将构筑并全面实施端到端的网络安全保障体系作为公司的重要发展战略之一，在遵从国家和地区安全法规和参考行业最佳实践的基础上，从政策、组织、流程、管理、技术和规范等方面建立和完善可持续、可信赖的安全保障体系，全面满足客户的网络安全需求。在业务流程方面，安全保障活动融入研发、供应链、市场与销售交付及技术服务等各环节中，作为质量管理体系的基本要求，通过管理制度和技术规范来确保其有效实施。在人员管理方面，富惠全体员工以及合作伙伴都必须严格执行公司相关安全政策，使安全理念融入整个组织之中。富惠对积极参与网络安全保障的员工给予奖励，对违反网络安全保障政策的员工给予处罚，违反相关法律法规的员工，将依法承担法律责任。本声明适用于上海富惠网络有限公司并符合国家的法律、法规。公司将不定期进行本声明的审核，根据相关法律规定进行重新修订",
    desc4:
      "针对数字权益类权益类",
    desc5:
      "1.已使用（充值或兑换成功），则不支持退换货",
    desc6:
      "2.未使用，可在订单内申请退款",
    desc7:
      "详询客服电话：400-008-1013（9：00am-17：00pm）",
    desc8:
      "富惠尊重用户的隐私权。从用户得到的信息将帮助富惠为用户在平台的行权、消费提供个性化服务，并且不断提升用户行权及消费体验。富惠采集的信息种类如下：您向富惠提供的信息：接收并存储您在富惠网站上或以其他任何方式提供给富惠的任何信息。您可以选择不提供某些信息，但是这样可能使您无法使用本网站的许多特色服务。富惠使用您提供的信息是为了回应您的要求，为您将来在本网站购物提供个性化服务，改善富惠的网站以及与您进行沟通。自动获取的信息：无论您何时与富惠进行沟通，富惠接收并储存的特定信息。移动设备：当您下载或使用本网站及其关联公司开发的应用时，富惠将可能收到关于您所处位置以及您的移动设备的信息，其中包含识别您的移动设备的特定号码。富惠将使用这些信息为您提供基于位置的定位相关服务。大多数移动设备将允许您关闭定位服务。多数情况下，这些设置在设备的设置菜单内。从其他来源获得的信息：富惠可能从其他合法来源收到关于您的信息并且将其加入富惠的用户信息库。我们深知个人信息对您的重要性，也深知为您的信息提供有效保护是我们业务健康可持续发展的基石。感谢您对富惠的信任！我们致力于维持您对我们的信任，恪守适用法律和我们对您的承诺，尽全力保证您的个人信息安全和合理使用。同时，我们郑重承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。",
    desc9:
      "富惠不会向其他实体披露您的个人数据，除非为代表富惠开展某些服务或为遵守法律要求所必要，富惠未授权该等服务提供商使用或披露该等数据。富惠通过合同要求该等服务提供商适当保护其代表富惠所处理的个人数据的隐私和安全。以下情况下，富惠亦可能披露与您有关的个人数据：",
    desc10:
      "(i)	若法律或诉讼程序要求富惠披露；",
    desc11:
      "(ii)	向执法机构或其他政府官员披露；",
    desc12:
      "(iii) 当富惠认为为防止人身伤害或财务损失、或与调查疑似或实际欺诈或不合法活动有关而有必要进行披露。",
    desc13:
      "(iv)	富惠还有权在富惠出售或转让富惠全部或部分业务或资产的情况下转让富惠持有的与您有关的个人数据。若发生该等出售或转让，富惠将尽合理努力指示受让人以符合本政策的方式使用您向富惠提供的个人数据。该等出售或转让后，您可就该等信息处理有关的任何问题联系富惠向其转让您个人信息的实体。",
    desc14:
      "富惠可能向位于您所在国家以外的接收人传输或披露个人数据。在您所在国家以外传输或披露个人信息可能受到限制，且富惠将采取所有必要措施以确保遵守适用的数据保护法律，尤其是，有关充分保护向您所在国家以外国家传输数据的法律要求。但请注意，富惠向其传输或披露您的个人数据的国家可能没有与您最初提供信息所在国家相同的数据保护法律，且在该国的数据保护法律项下您可能无法获得有关保护您的数据的机制。",
    desc15:
      "若您希望了解有关富惠如何处理或访问您的个人数据的更多信息；纠正或删除与您有关的任何个人数据；撤销您就某些类型数据处理所做出的同意；变更您的首选项或将您的电子邮件地址从富惠的邮寄清单中删除；或若您对富惠的隐私操作有任何问题、意见、顾虑或投诉，请通过以下方式联系富惠：",
    desc16:
      "发送电子邮件至：service_s@link2shops.com",
    desc17:
      "请详细说明相关问题，以便富惠回复您的要求。富惠将会在合理时间内评估和回复所有投诉。若您对富惠的回复不满意，您可向您所在司法管辖区的相关监管机构投诉。",
    }
};



// WEBPACK FOOTER //
// ./src/assets/lang/zh-CN.js